import * as React from 'react';

import {
  CommunicationActionLink,
  CommunicationLayout,
  CommunicationErrorIllustration,
} from '../../../../components/Communication';
import { IBasePaymentCommunicationProps } from '../../types';

export interface IPaymentCanceledCommunicationProps extends IBasePaymentCommunicationProps {
  onAction: () => void;
  href: string;
}

export const PaymentCanceled: React.FC<IPaymentCanceledCommunicationProps> = ({ onAction, href, testId }) => {
  return (
    <CommunicationLayout
      image={<CommunicationErrorIllustration />}
      title={'Ох, похоже вы не оплатили отчёт'}
      testId={testId}
      message="Возможно, случилась какая-то ошибка. К сожалению, чтобы заказать отчёт нужно будет заново ответить на вопросы анкеты."
      action={
        <CommunicationActionLink href={href} onClick={onAction}>
          Заказать отчёт заново
        </CommunicationActionLink>
      }
    />
  );
};

PaymentCanceled.displayName = 'PaymentCanceled';
